
import _ from 'underscore'

import service from '../service/examine.js'
import CONSTANT from '../constant/examine.js'
import orderService from '../service/order'

export default {
  getExamineOrderList ({ commit }, query) {
    return new Promise((resolve, reject) => {
      let Api = service.getExamineOrderList
      if(query.orderStatus === CONSTANT.EXAMINE_ORDER_UN_PAY) {
        // 如果是待支付单，则请求订单中心的接口
        Api = orderService.getOrderList
        query = {
          ...query,
          sortKey: 2,
          sortType: 1,
          type: 2, // 2表示待支付单
        }
      } else if(query.orderStatus === CONSTANT.EXAMINE_ORDER_STATUS_ALL) {
        // 如果是全部订单，要将待支付单合并进去
        Api = (orderQuery) => new Promise((resolve, reject) => {
          let unPayOrderList = []
          // 先查到所有待支付单
          orderService.getOrderList({
            pageSize: 10,
            pageNum: 1,
            sortKey: 2,
            sortType: 1,
            type: 2, // 2表示待支付单
          }).then(data => {
            if(!_.isEmpty(data)) {
              unPayOrderList = data.list.map(item => {
                return {
                  ...item,
                  isUnpay: true,
                }
              }) || []
            }
            // 再查到所有体检订单
            return service.getExamineOrderList(orderQuery)
          }).then(examineOrderData => {
            if(_.isEmpty(examineOrderData)) {
              examineOrderData = { list: [] }
            }
            resolve({
              ...examineOrderData,
              // 合并两种订单
              list: unPayOrderList.concat(examineOrderData.list || [])
            })
          }).catch(e => {
            reject(e)
          })
        })
      }

      return Api(query).then(data => {
        if (_.isEmpty(data)) {
          resolve(data)
          commit(CONSTANT.EXAMINE_ORDER_GET_ALL_EMPTY)
          return data
        }
        resolve(data)
        commit(CONSTANT.EXAMINE_ORDER_GET_ALL_SUCCESS, data)
        return data
      }, e => {
        reject(e)
        commit(CONSTANT.EXAMINE_ORDER_GET_ALL_ERROR, e)
      })
    })
  },
  getExamineOrderListMore ({ commit }, query) {
    return new Promise((resolve, reject) => {
      let Api = service.getExamineOrderList
      if(query.orderStatus === CONSTANT.EXAMINE_ORDER_UN_PAY) {
        // 如果是待支付单，则请求订单中心的接口
        Api = orderService.getOrderList
        query = {
          ...query,
          sortKey: 2,
          sortType: 1,
          type: 2, // 2表示待支付单
        }
      }
      return Api(query).then(data => {
        if (_.isEmpty(data)) {
          resolve(data)
          return data
        }
        resolve(data)
        commit(CONSTANT.EXAMINE_ORDER_GET_ALL_MORE_SUCCESS, data)
        return data
      }, e => {
        reject(e)
      })
    })
  },
  getAgencyList ({ commit }, query) {
    return new Promise((resolve, reject) => {
      return service.getAgencyList(query).then(data => {
        resolve(data)
        commit(CONSTANT.EXAMINE_AGENCY_GET_SUCCESS, data)
        return data
      }, e => {
        reject(e)
        commit(CONSTANT.EXAMINE_AGENCY_GET_ERROR, e)
      })
    })
  },
  getScheduleList ({ commit }, query) {
    return new Promise((resolve, reject) => {
      return service.getScheduleList(query).then(data => {
        resolve(data)
        commit(CONSTANT.EXAMINE_AGENCY_GET_SCHEDULE_SUCCESS, data)
        return data
      }, e => {
        reject(e)
        commit(CONSTANT.EXAMINE_AGENCY_GET_SCHEDULE_ERROR, e)
      })
    })
  },
  getExamineReserveList ({ commit }, query) {
    return new Promise((resolve, reject) => {
      return service.getExamineReserveList(query).then(data => {
        resolve(data)
        commit(CONSTANT.EXAMINE_RESERVE_GET_ORDER_LIST_SUCCESS, data)
        return data
      }, e => {
        reject(e)
        commit(CONSTANT.EXAMINE_RESERVE_GET_ORDER_LIST_ERROR, e)
      })
    })
  },
  getExamineReserveDetail ({ commit }, query) {
    return new Promise((resolve, reject) => {
      return service.getExamineReserveDetail(query).then(data => {
        resolve(data)
        commit(CONSTANT.EXAMINE_RESERVE_GET_ORDER_SUCCESS, data)
        return data
      }, e => {
        reject(e)
        commit(CONSTANT.EXAMINE_RESERVE_GET_ORDER_ERROR, e)
      })
    })
  },
  createExamineReserve({ commit }, query) {
    return new Promise((resolve, reject) => {
      return service.createExamineReserve(query).then(data => {
        resolve(data)
        return data
      }, e => {
        reject(e)
      })
    })
  },
  updateExamineReserve({ commit }, query) {
    return new Promise((resolve, reject) => {
      return service.updateExamineReserve(query).then(data => {
        resolve(data)
        return data
      }, e => {
        reject(e)
      })
    })
  },
  cancelExamineReserve({ commit }, query) {
    return new Promise((resolve, reject) => {
      return service.cancelExamineReserve(query).then(data => {
        resolve(data)
        return data
      }, e => {
        reject(e)
      })
    })
  },
  getAgencyDetail({ commit }, query) {
    return new Promise((resolve, reject) => {
      return service.getAgencyDetail(query).then(data => {
        resolve(data)
        return data
      }, e => {
        reject(e)
      })
    })
  },
  getExamineResult({ commit }, query) {
    return new Promise((resolve, reject) => {
      return service.getExamineResult(query).then(data => {
        resolve(data)
        return data
      }, e => {
        reject(e)
      })
    })
  },
  getPackagesListOfAgency({ commit }, query) {
    return new Promise((resolve, reject) => {
      return service.getPackagesListOfAgency(query).then(data => {
        resolve(data)
        return data
      }, e => {
        reject(e)
      })
    })
  },
  editExaminer({ commit }, query) {
    return new Promise((resolve, reject) => {
      return service.editExaminer(query).then(data => {
        resolve(data)
        return data
      }, e => {
        reject(e)
      })
    })
  },
  addExaminer({ commit }, query) {
    return new Promise((resolve, reject) => {
      return service.addExaminer(query).then(data => {
        resolve(data)
        return data
      }, e => {
        reject(e)
      })
    })
  },
  getExaminerList({ commit }, query) {
    return new Promise((resolve, reject) => {
      return service.getExaminerList(query).then(data => {
        resolve(data)
        commit(CONSTANT.EXAMINE_GET_EXAMINER_LIST_SUCCESS, data)
        return data
      }, e => {
        reject(e)
      })
    })
  },
  getExaminerDetail({ commit }, query) {
    return new Promise((resolve, reject) => {
      return service.getExaminerDetail(query).then(data => {
        resolve(data)
        commit(CONSTANT.EXAMINE_GET_EXAMINER_LIST_SUCCESS, data)
        return data
      }, e => {
        reject(e)
      })
    })
  },
  // 删除已关闭 已取消订单
  deleteExamineOrder({commit}, query) {
    return new Promise((resolve, reject) => {
      return service.deleteExamineOrder(query).then(data => {
        return resolve(data)
      }, e => {
        return reject(e)
      })
    })
  }
}

